// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Date {
  isInPast: () => boolean;
}

Date.prototype.isInPast = function (): boolean {
  const firstDate = new Date(this);
  const today = new Date();
  return firstDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
};
